var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnfilledStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.70931 2.01092L10.9412 4.49501C11.1092 4.8408 11.5571 5.17249 11.9351 5.236L14.1678 5.61002C15.5957 5.84997 15.9317 6.89441 14.9028 7.92474L13.167 9.67488C12.873 9.97126 12.712 10.5429 12.803 10.9522L13.3 13.1187C13.6919 14.8336 12.789 15.497 11.2842 14.6007L9.19138 13.3516C8.81346 13.1258 8.19053 13.1258 7.80553 13.3516L5.71279 14.6007C4.21495 15.497 3.30505 14.8265 3.69701 13.1187L4.19395 10.9522C4.28494 10.5429 4.12396 9.97126 3.82999 9.67488L2.09419 7.92474C1.0723 6.89441 1.40126 5.84997 2.8291 5.61002L5.06186 5.236C5.43281 5.17249 5.88076 4.8408 6.04874 4.49501L7.2806 2.01092C7.95253 0.663025 9.04438 0.663025 9.70931 2.01092Z",
    fill: "#6D6D6D",
    fillOpacity: 0.25,
    stroke: "#6D6D6D",
    strokeOpacity: 0.05,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnfilledStar);
export default __webpack_public_path__ + "static/media/unfilledStar.96421ac856dbf3931677c55620800971.svg";
export { ForwardRef as ReactComponent };